export const EQUIPMENT = [
  { id: "forestry_mulcher", label: "Forestry Mulcher" },
  { id: "excavator", label: "Excavator" },
  { id: "grader", label: "Motor Grader / Grading" },
  { id: "skid_steer", label: "Skid Steer / Track Loader" },
  { id: "bulldozer", label: "Bulldozer" },
  { id: "backhoe", label: "Backhoe Loader" },
  { id: "chipper", label: "Wood Chipper" },
  { id: "chainsaw", label: "Chainsaw / Hand Crew" },
];

export const EXPERIENCE_LEVELS = [
  "Less than 1 year",
  "1–2 years",
  "3–5 years",
  "6–10 years",
  "10+ years",
];

export const CDL_CLASSES = ["Class A", "Class B", "Class C", "None / In progress"];

export const EMPLOYMENT_TYPES = [
  { id: "full_time", label: "Full-Time", desc: "40+ hrs/week, steady schedule" },
  { id: "part_time", label: "Part-Time", desc: "Flexible hours, as-needed work" },
  { id: "both", label: "Open to Both", desc: "Whatever fits the crew's needs" },
];

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const TIMES = ["Early Morning", "Daytime", "Evenings", "Weekends Only"];

export const STATUS_OPTIONS = [
  { id: "new", label: "New" },
  { id: "reviewing", label: "Reviewing" },
  { id: "interviewed", label: "Interviewed" },
  { id: "hired", label: "Hired" },
  { id: "rejected", label: "Not a Fit" },
];
